
import { AlertTriangle, Check, Info } from 'lucide-react';
import { NotificationType } from '@/types/notifications-types';

interface NotificationIconProps {
  type: NotificationType;
  size?: number;
}

/**
 * Component to display the appropriate icon for a notification type
 */
const NotificationIcon: React.FC<NotificationIconProps> = ({ type, size = 20 }) => {
  switch (type) {
    case 'success':
      return <Check className="text-green-500" size={size} />;
    case 'warning':
      return <AlertTriangle className="text-amber-500" size={size} />;
    case 'error':
      return <AlertTriangle className="text-red-500" size={size} />;
    case 'info':
    default:
      return <Info className="text-blue-500" size={size} />;
  }
};

export default NotificationIcon;
